module.exports = __webpack_public_path__ + "static/media/DOLCE VITA-01.2cce1665.svg";